import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { UserPreferencesNotificationsStatus } from "../user-preferences-notifications-status";
import { useUserPreferencesNotificationsContext } from "../user-preferences-notifications.context";

export const UserPreferencesNotificationsFooter = () => {
  const { t } = useTranslation();
  const { isPending, isDirty, onSave, onCancel } =
    useUserPreferencesNotificationsContext();

  return (
    <>
      <UserPreferencesNotificationsStatus />
      <Button onClick={onCancel} disabled={!isDirty || isPending}>
        {t("global:cancel")}
      </Button>
      <Button
        loading={isPending}
        type="primary"
        onClick={onSave}
        disabled={!isDirty}
      >
        {t("global:save")}
      </Button>
    </>
  );
};
